var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgLink = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4A5569",
    d: "M13.818 7.843a6.428 6.428 0 01.015 9.08l-.015.015-2.843 2.843a6.437 6.437 0 01-9.094 0 6.436 6.436 0 010-9.094l1.57-1.57c.416-.417 1.133-.14 1.154.448.028.75.162 1.503.41 2.23a.683.683 0 01-.16.704l-.553.553c-1.186 1.186-1.223 3.117-.05 4.314a3.05 3.05 0 004.33.022l2.843-2.843a3.045 3.045 0 00-.438-4.671.682.682 0 01-.294-.533 1.689 1.689 0 01.495-1.261l.891-.89a.68.68 0 01.871-.074c.31.216.6.46.868.727zm5.963-5.962a6.438 6.438 0 00-9.095 0L7.843 4.724l-.015.015a6.43 6.43 0 00.883 9.807.68.68 0 00.871-.074l.891-.89c.353-.354.512-.814.495-1.261a.678.678 0 00-.294-.534 3.046 3.046 0 01-.437-4.671l2.843-2.842a3.05 3.05 0 014.329.021c1.174 1.198 1.137 3.128-.05 4.314l-.553.554a.681.681 0 00-.16.703c.248.727.383 1.48.41 2.23.022.588.739.865 1.155.449l1.57-1.57a6.438 6.438 0 000-9.094z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLink, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/link.83acf116.svg";
export { ForwardRef as ReactComponent };